(function() {
  'use strict';

  angular
    .module('survey.surveyCtrl', [
      'survey.multipleChoice',
      'survey.essay',
      'survey.surveyIntro',
      'survey.surveyOutro',
      'service.surveyServiceFactory'
    ])
    .controller('SurveyCtrl', SurveyCtrl);

  SurveyCtrl.$inject = ['$scope', 'SurveyServiceFactory', 'Navigation', '$timeout', 'Sension', 'ContentPlayerService'];

  function SurveyCtrl($scope, SurveyServiceFactory, Navigation, $timeout, Sension, ContentPlayerService) {

    var viewMapping = {
      DTOQuestionMultipleChoice: 'survey/multipleChoice.html',
      DTOQuestionEssay: 'survey/essay.html'
    };

    var incompleteImageMap = {
      DTOQuestionMultipleChoice: 'incomplete_question_MC.png',
      DTOQuestionEssay: 'incomplete_question_Survey.png'
    };

    $scope.surveySrc = '';
    $scope.incompleteImgSrc = '';

    $scope.state = {
      name: 'ready',
      answerSubmitted: false,
      answerSelected: false
    };

    $scope.view = {
      questionText: { height: '50px' }
    };

    var navigation = $scope.navigation;

    var SurveyService = SurveyServiceFactory.getSurveyService(navigation.isPreview);

    function allowNextNav() {
      return $scope.state.answerSubmitted || $scope.state.isOptional || navigation.freeNavigation;
    }

    function needToShowWarningPopup() {
      return $scope.state.isOptional && slideIsNotEmpty() && !$scope.state.skipConfirmed && !navigation.isPreview;
    }

    navigation.intercept('navigate', function interceptNavigate(navigateTo) {
      if (navigateTo !== navigation.directions.next)
        return true;
      if (needToShowWarningPopup()) {
        showWarningPopup();
        return false;  //Prevent them from swiping past if they entered text but didn't submit
      }

      return true;
    });

    navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
      return navigateTo !== navigation.directions.next || allowNextNav();
    });

    $scope.leftArrowClass = function() {
      return 'previousQuestionEnabled';
    };

    $scope.requestPreviousSlide = navigation.navigatePrevious;
    $scope.requestNextSlide = function() {
      if (needToShowWarningPopup()) {
        showWarningPopup();
        return false;
      }
      navigation.navigateNext();
    };

    function slideIsNotEmpty() {
      return $scope.state.answerSelected && !$scope.state.answerSubmitted
    }

    $scope.rightArrowClass = function() {
      return allowNextNav() ? 'nextQuestionEnabled' : 'nextQuestionDisabled';
    };

    function showWarningPopup() {
      $scope.state.skipConfirmed = false;
      $scope.app.modal = {
        url: 'modals/modalSkipEssay.html', skipConfirmed: function() {
          skipSlide();
        }
      };
    }

    // child slide controllers will set this
    $scope.answer = {
      selectedAnswer: null
    };

    var progressStatusWatcher = $scope.$on('$progressProcessingCompleted', quizReady);

    function quizReady() {
      if (!_.isEmpty(ContentPlayerService.serviceStatus))
        return;

      progressStatusWatcher();
      setup();
    }

    function setup() {
      if (!$scope.currentSlide || $scope.currentSlide.__type != 'SurveyQuestionSlideInfo')
        return;

      $scope.question = $scope.currentSlide.question;

      var surveyId = $scope.currentSlide.surveyId;
      $scope.amountOfQuestions = $scope.quizIdAmountOfQuestions[surveyId].total;

      $scope.surveySrc = $scope.question.isValid ? viewMapping[$scope.question.__type] : null;

      if (!$scope.question.isValid) {
        setIncompleteImgSrc();
      }

      $scope.quizCompleted = $scope.currentSlide.quizCompleted;

      $scope.questionAnswers = [];
      if ($scope.question.answers)
        $scope.questionAnswers = $scope.question.answers.concat();
      else if ($scope.question.options)
        $scope.questionAnswers = $scope.question.options.concat();

      setInitialState();

      $timeout(function() {
        // Let DOM update with survey resized before we show it to the user.
        Navigation.state = Navigation.states.ready;
        Navigation.showNavControls = true;
      }, 250);
    }

    quizReady();

    $scope.submitAnswer = function() {
      if (!canSubmitAnswer()) return false;
      setProcessingState();

      var slide = _.clone($scope.currentSlide);
      slide.engagementScore = $scope.sensionEnabledDuringCModule ? Sension.getAggregateEngagement() : null;

      var answer = {
        surveyId: $scope.currentSlide.surveyId,
        questionId: $scope.question.id,
        slide: slide,
        courseId: $scope.courseId,
        answer: $scope.answer.selectedAnswer,
        engagementScore: $scope.sensionEnabledDuringCModule ? Sension.getAggregateEngagement() : null
      };
      $scope.question.selectedAnswer = $scope.answer.selectedAnswer;

      answer.cModuleId = $scope.cModuleId;
      SurveyService.answerQuestion(answer, answerQuestionSucess, answerQuestionError);
    };

    function answerQuestionSucess(result) {
      if (result.frameIsStale)
        return $scope.onStaleFrameFound();

      $scope.quizIdAmountOfQuestions[$scope.currentSlide.surveyId].completed++;
      $scope.quizCompleted = result.quizCompleted;
      $scope.currentSlide.hasAnswer = result.hasAnswer;


      // Deprecate - remove when .NET player backend is removed
      if (result.completionInfo)
        $scope.setCompletionInfo(result.completionInfo);
      if (result.quizLastSlideInfo)
        $scope.setQuizLastSlideInfo(result.quizLastSlideInfo);
      if (result.quizCompleted)
        $scope.markQuizComplete($scope.currentSlide.quizId);

      setAnsweredState();
      cleanupQuestionStorage();
      $scope.state.submissionMsgVisible = true;
    }

    function answerQuestionError(error) {
      if (error && error.data === 'ContentModified') {
        $scope.onStaleFrameFound();
        return true;
      }
    }

    function canSubmitAnswer() {
      if ($scope.state.name === 'processing')
        return false;
      return $scope.state.answerSelected;
    }

    function setAnsweredState() {
      $scope.state = {
        answerSubmitted: true,
        answerSelected: true,
        name: 'answerCorrect'
      };
    }

    function cleanupQuestionStorage() {
      $scope.quizAnswerStorage.clearQuestionAnswer($scope.question.id);
    }

    function setInitialState() {
      if (!$scope.currentSlide) return;
      if ($scope.currentSlide.hasAnswer) {
        $scope.answer.selectedAnswer = $scope.question.selectedAnswer;
        setAnsweredState();
        $scope.state.submissionMsgVisible = true;
        return;
      }
      $scope.state = {
        name: 'ready',
        answerSubmitted: false,
        answerSelected: false,
        essayText: '',
        isOptional: $scope.currentSlide.isOptional,
        submissionMsgVisible: false
      };
      $scope.skipAndRightNavRequested = false;

      getUserAnswerFromStorage();
    }


    function getUserAnswerFromStorage() {
      var result = $scope.quizAnswerStorage.getQuestionAnswer($scope.question.id);
      if (!result) return;

      $scope.currentSlide.question.answer = result;

      if ($scope.currentSlide.question.__type === 'DTOQuestionEssay')
        $scope.currentSlide.question.answer = result.answer;

      $scope.state.answerSelected = true;
    }

    function setProcessingState() {
      $scope.state.name = 'processing';
    }

    $scope.actionBtn = {
      txt: '',
      clazz: ''
    };

    $scope.$watch(function setActionButton() {
      if (!_.isEmpty(ContentPlayerService.serviceStatus))
        return;

      var obj = {
        txt: '',
        clazz: ''
      };

      if ($scope.state.name === 'processing') {
        obj.txt = 'Submit';
        obj.clazz = 'btn-primary disabled';
      } else if (!$scope.state.answerSubmitted && $scope.state.answerSelected) {
        obj.txt = 'Submit';
        obj.clazz = 'btn-primary';
      } else {
        obj.txt = '';
      }

      if (obj.txt == $scope.actionBtn.txt && obj.clazz == $scope.actionBtn.clazz)
        return;

      $scope.actionBtn.txt = obj.txt;
      $scope.actionBtn.clazz = obj.clazz;
    });


    $scope.onActionButtonClick = function() {
      if (!$scope.state.answerSubmitted && $scope.state.answerSelected)
        return $scope.submitAnswer();
    };

    $scope.onQuestionGripSlide = function(event) {
      var newHeight = Math.min(600, event.originalEvent.pageY - 100);
      $scope.view.questionText.height = newHeight + 'px';
    };

    function skipSlide() {
      $scope.state.skipConfirmed = true;
      angular.element('#skipRequestedModal').modal('hide');
      if (slideIsNotEmpty()) {
        storeUserAnswer();
      }
      $scope.navigation.navigateNext();
    }

    function storeUserAnswer() {
      $scope.quizAnswerStorage.setQuestionAnswer($scope.question.id, $scope.currentSlide.question.answer, $scope.currentSlide.questionModifiedTimestamp);
    }

    function setIncompleteImgSrc() {
      $scope.incompleteImgSrc = 'images/' + incompleteImageMap[$scope.question.__type];
    }
  }
})();